import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { toast } from "react-toastify";
import Tick from "../../../icons/tick.svg";
import Cross from "../../../icons/cross.svg";
import Minus from "../../../icons/minus.svg";
import Documento from "../../../icons/document.svg";
import Aviso from "../../../icons/email.svg";
import { Link } from "react-router-dom";
import HeaderBackground from "../../../images/banner_proveedores.jpg";
import { abrirArchivo } from "../../../providers/documentos";
import { UsuarioContext } from "../../../providers/userContext";
import { getProveedor, getUserPropertieList } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { cambiarFormatoNombre } from "../../../functions/funciones";
import CircularProgress from "@mui/material/CircularProgress";

const Proveedor = (props) => {
  const { t } = useTranslation(['suppliers', 'properties', 'common']);
  const user = useContext(UsuarioContext);
  const [proveedor, setProveedor] = useState({});
  const [fincas, setFincas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    getProveedor(props.params.nifProveedor)
      .then((res) => {
        let proveedor = {
          ...res,
          documentos: {
            lopd: { pendiente: true, ruta: "", validado: false },
            seguro: { pendiente: false, ruta: "", validado: true },
            vigilancia: { pendiente: false, ruta: "", validado: false },
            evaluacionRiesgos: { pendiente: false, ruta: "", validado: true },
          }
        }
        setProveedor(proveedor);
        getUserPropertieList(props.params.nifProveedor)
          .then((resP) => {
            setFincas(resP.properties)
          })
          setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // window.location.replace("/");
      });
  }, []);

  return isLoading ? <CircularProgress style={{ color: '#92004D', position: 'absolute', top: '50%', left: '50%' }} /> :
    <>
      <>
        <BreadCrumb rutas={[{ path: '/proveedores/', label: t('title') }, { path: `/proveedores/${props.params.nif}`, label: `${proveedor?.razonSocial}` }]} style={{ margin: '0 10px' }} />
        <div className="pageGrid">
          <div className="gridCard">
            <div className="gridHead">{t('sections.generalInfo')}</div>
            <div className="gridSubhead">{t('sections.companyData')}</div>
            <div className="datosGrid">
              <p>
                <b>{t('detail.supplierName')}</b> {proveedor.razonSocial}
              </p>
              <p>
                <b>{t('detail.address')}</b> {proveedor.direccion}
              </p>
              <p>
                <b>{t('detail.nif')}</b> {proveedor.nif}
              </p>
              <p>
                <b>{t('detail.municipality')}</b> {cambiarFormatoNombre(proveedor?.municipio)}
              </p>
              <p>
                <b>{t('detail.contactPerson')}</b> {proveedor.nombreContacto}
              </p>
              <p>
                <b>{t('detail.postalCode')}</b> {proveedor.codigoPostal}
              </p>
              <p>
                <b>{t('detail.contactEmail')}</b> {proveedor.emailContacto}
              </p>
              <p>
                <b>{t('detail.province')}</b> {proveedor.provincia}
              </p>
              <p>
                <b>{t('detail.phone')}</b> {proveedor.telefonoContacto}
              </p>
              <p>
                <b>{t('detail.lastReclamation')}</b>{" "}
                {proveedor.ultimaReclamacion !== undefined &&
                  proveedor.ultimaReclamacion > proveedor.createdAt
                  ? new Date(proveedor.ultimaReclamacion).toLocaleDateString()
                  : "-"}
              </p>
            </div>
            <div className="gridSubhead">{t('sections.companyDocuments')}</div>
            <table style={{ margin: 15 }}>
              <thead>
                <tr
                  style={{
                    fontSize: 10,
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  <th></th>
                  <th></th>
                  <th style={{ margin: 5 }}>{t('common:actions.view')}</th>
                </tr>
              </thead>
              <tbody>
                {/*RC*/}
                <tr>
                  <td>
                    {proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.validado && new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.fechaCaducidad) > new Date() ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.rc')}{" "}
                    <small style={{ display: "block", margin: "5px 0", color: new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.fechaCaducidad) > new Date() ? 'black': 'red' }}>
                      {proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.fechaCaducidad !== null
                        ? new Date(
                          proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.fechaCaducidad
                        ).toLocaleDateString()
                        : "-"}
                    </small>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      style={!proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                      src={Documento}
                      alt="Ver"
                      className="tableIcon"
                      onClick={() =>
                        abrirArchivo(proveedor?.docssupps?.find(d => d.tipoDoc === 2)?.ruta)
                      }
                    />
                  </td>
                </tr>
                {/*Modalidad Preventiva*/}
                <tr>
                  <td>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.validado && new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.fechaCaducidad) > new Date() ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.preventiveModality')}{" "}
                    {proveedor?.noProcede ? (
                      <small style={{ display: "block", margin: "5px 0" }}><strong>{t('detail.notApplicable')}</strong></small>
                    ) : (
                      <small style={{ display: "block", margin: "5px 0", color: new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.fechaCaducidad) > new Date() ? 'black': 'red' }}>
                        {proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.fechaCaducidad !==
                          null
                          ? new Date(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.fechaCaducidad
                          ).toLocaleDateString()
                          : "-"}
                      </small>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : (
                      <img
                        style={!proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                        src={Documento}
                        alt="Ver"
                        className="tableIcon"
                        onClick={() =>
                          abrirArchivo(proveedor?.docssupps?.find(d => d.tipoDoc === 3)?.ruta)
                        }
                      />
                    )}
                  </td>
                </tr>
                {/*Evaluacion riesgos*/}
                <tr>
                  <td>
                    {proveedor?.docssupps?.find(d => d.tipoDoc === 5)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 5)?.validado ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.riskAssessment')}{" "}
                    <small style={{ display: "block", margin: "5px 0" }}>-</small>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      style={!proveedor?.docssupps?.find(d => d.tipoDoc === 5)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 5)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                      src={Documento}
                      alt="Ver"
                      className="tableIcon"
                      onClick={() =>
                        abrirArchivo(
                          proveedor?.docssupps?.find(d => d.tipoDoc === 5)?.ruta
                        )
                      }
                    />
                  </td>
                </tr>
                {/*Planificación preventiva*/}
                <tr>
                  <td>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.validado ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.preventivePlanning')}{" "}
                    {proveedor?.noProcede ? (
                      <small style={{ display: "block", margin: "5px 0" }}><strong>{t('detail.notApplicable')}</strong></small>
                    ) : (
                      <small style={{ display: "block", margin: "5px 0", color: new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.fechaCaducidad) > new Date() ? 'black': 'red' }}>
                        {proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.fechaCaducidad !== null
                          ? new Date(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.fechaCaducidad
                          ).toLocaleDateString()
                          : "-"}
                      </small>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : (
                      <img
                        style={!proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                        src={Documento}
                        alt="Ver"
                        className="tableIcon"
                        onClick={() =>
                          abrirArchivo(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 4)?.ruta
                          )
                        }
                      />
                    )}
                  </td>
                </tr>
                {/*Listado trabajadores*/}
                <tr>
                  <td>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.validado ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.workersList')}{" "}
                    {proveedor?.noProcede ? (
                      <small style={{ display: "block", margin: "5px 0" }}>
                        <strong>{t('detail.notApplicable')}</strong>
                      </small>
                    ) : (
                      <small
                        style={{
                          display: "block",
                          margin: "5px 0",
                          color:
                            proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.validado
                              ? "green"
                              : proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.pendiente
                              ? "orange"
                              : "red",
                        }}
                      >
                        {proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.fechaCaducidad !==
                          null
                          ? new Date(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.fechaCaducidad
                          ).toLocaleDateString()
                          : "-"}
                      </small>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : (
                      <img
                        style={!proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                        src={Documento}
                        alt="Ver"
                        className="tableIcon"
                        onClick={() =>
                          abrirArchivo(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 10)?.ruta
                          )
                        }
                      />
                    )}
                  </td>
                </tr>
                {/*RLC*/}
                <tr>
                  <td>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.validado && new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.fechaCaducidad) > new Date() ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.rlc')}{" "}
                    {proveedor?.noProcede ? (
                      <small style={{ display: "block", margin: "5px 0" }}><strong>{t('detail.notApplicable')}</strong></small>
                    ) : (
                      <small style={{ display: "block", margin: "5px 0", color: new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.fechaCaducidad) > new Date() ? 'black': 'red' }}>
                        {proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.fechaCaducidad !== null
                          ? new Date(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.fechaCaducidad
                          ).toLocaleDateString()
                          : "-"}
                      </small>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : (
                      <img
                        style={!proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                        src={Documento}
                        alt="Ver"
                        className="tableIcon"
                        onClick={() =>
                          abrirArchivo(proveedor?.docssupps?.find(d => d.tipoDoc === 9)?.ruta)
                        }
                      />
                    )}
                  </td>
                </tr>
                {/*RNT*/}
                <tr>
                  <td>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.validado && new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.fechaCaducidad) > new Date() ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.rnt')}{" "}
                    {proveedor?.noProcede ? (
                      <small style={{ display: "block", margin: "5px 0" }}><strong>{t('detail.notApplicable')}</strong></small>
                    ) : (
                      <small style={{ display: "block", margin: "5px 0", color: new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.fechaCaducidad) > new Date() ? 'black': 'red' }}>
                        {proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.fechaCaducidad !== null
                          ? new Date(
                            proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.fechaCaducidad
                          ).toLocaleDateString()
                          : "-"}
                      </small>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      <span></span>
                    ) : (
                      <img
                        style={!proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                        src={Documento}
                        alt="Ver"
                        className="tableIcon"
                        onClick={() =>
                          abrirArchivo(proveedor?.docssupps?.find(d => d.tipoDoc === 8)?.ruta)
                        }
                      />
                    )}
                  </td>
                </tr>
                {/*Justificante SC*/}
                <tr>
                  <td>
                    {proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.validado && new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.fechaCaducidad) > new Date() ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.socialSecurityCert')}{" "}
                    <small style={{ display: "block", margin: "5px 0", color: new Date(proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.fechaCaducidad) > new Date() ? 'black': 'red' }}>
                      {proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.fechaCaducidad !==
                        null
                        ? new Date(
                          proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.fechaCaducidad
                        ).toLocaleDateString()
                        : "-"}
                    </small>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      style={!proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.pendiente && !proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                      src={Documento}
                      alt="Ver"
                      className="tableIcon"
                      onClick={() =>
                        abrirArchivo(proveedor?.docssupps?.find(d => d.tipoDoc === 6)?.ruta)
                      }
                    />
                  </td>
                </tr>
                {/*Declaracion responsable*/}
                <tr>
                  <td>
                    {proveedor.documentos?.declaracionResponsable?.[user.id]
                      ?.pendiente ? (
                      <img src={Minus} alt={t('common:status.pending')} className="tableIcon" />
                    ) : proveedor.documentos?.declaracionResponsable?.[user.id]
                      ?.validado ? (
                      <img src={Tick} alt={t('common:status.validated')} className="tableIcon" />
                    ) : (
                      <img src={Cross} alt={t('common:status.notValidated')} className="tableIcon" />
                    )}
                  </td>
                  <td style={{ width: "100%" }}>
                    {t('documentTypes.responsibleDeclaration')}{" "}
                    <small style={{ display: "block", margin: "5px 0" }}>-</small>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      style={!proveedor?.documentos?.declaracionResponsable?.pendiente && !proveedor?.documentos?.declaracionResponsable?.validado ? { opacity: 0.4, cursor: "default" } : {}}
                      src={Documento}
                      alt="Ver"
                      className="tableIcon"
                      onClick={() =>
                        abrirArchivo(
                          proveedor.documentos?.declaracionResponsable?.[user.id]
                            ?.ruta
                        )
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="gridCard">
            <div className="gridHead">{t('properties:title').toUpperCase()}</div>
            <table style={{ margin: 15 }}>
              <thead>
                <tr
                  style={{
                    fontSize: 10,
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  <th></th>
                  <th>{/* Aviso */}</th>
                </tr>
              </thead>
              <tbody>
                {fincas?.length === 0 || fincas === undefined ? t('properties:noCommunities') :
                fincas?.map((e, i) => {
                  return (
                    <tr key={i}>
                      <td style={{ width: "100%", padding: "5px 0" }}>
                        <Link to={"/comunidades/" + e.nif}>{e.razonSocial}</Link>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {/* <img src={Aviso} alt="Aviso" className="tableIcon" /> */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    </>
};

export default withRouter(Proveedor);